/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} ItemInputs */

const en_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`item`)
};

const es_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`artículo`)
};

const fr_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`article`)
};

const de_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artikel`)
};

const ja_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`商品`)
};

const zh_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`项`)
};

const ar_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`عنصر`)
};

const id_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`item`)
};

const it_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`articolo`)
};

const ru_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`товар`)
};

const pt_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`item`)
};

const ko_item = /** @type {(inputs: ItemInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`개 항목`)
};

/**
* | output |
* | --- |
* | "item" |
*
* @param {ItemInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const item = /** @type {((inputs?: ItemInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<ItemInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_item(inputs)
	if (locale === "es") return es_item(inputs)
	if (locale === "fr") return fr_item(inputs)
	if (locale === "de") return de_item(inputs)
	if (locale === "ja") return ja_item(inputs)
	if (locale === "zh") return zh_item(inputs)
	if (locale === "ar") return ar_item(inputs)
	if (locale === "id") return id_item(inputs)
	if (locale === "it") return it_item(inputs)
	if (locale === "ru") return ru_item(inputs)
	if (locale === "pt") return pt_item(inputs)
	return ko_item(inputs)
});